import { AtivoModel } from './AtivoModel';

export class GraficoAtivoModel {
    grafico: String
    texto: String
}